<!-- Section État de la pile -->
<app-display-rubrique-status-with-warning
  [title]="'P00030.status.battery' | translate"
  [warning]="actionStack!.getValue('taSEtatPile') === 1"
  [icon]="'fa-exclamation-triangle'"
  [text]="'P00030.status.batteryOK' | translate"
/>

<!-- Tension de la pile (support technique seulement) -->
@if (isSupportTechnique()) {
  <app-display-rubrique-status
    [title]="'P00030.status.batteryVoltage' | translate"
    [value]="mVToVolt(actionStack!.getValue('taSTensionPile')) ?? ''"
  />
}

<!-- Connexion produit au coffret -->
<app-display-rubrique-status-with-warning
  [title]="'P00030.status.productPresence' | translate"
  [warning]="hasProductWarning() === 2"
  [icon]="'fa-exclamation-triangle'"
  [text]="'P00030.status.ok' | translate"
/>
